"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextField = function TextField(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      status = _ref.status,
      noMb = _ref.noMb,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? _noop2.default : _ref$onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('py-3 pl-3 pr-8 w-full', noMb && 'mb-0', className),
    onClick: onClick,
    onKeyDown: onClick,
    tabIndex: 0,
    role: "button"
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: "uppercase font-bold mb-2 text-sm"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(status && "text-".concat(status))
  }, value));
};

TextField.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  title: _propTypes.default.string,
  status: _propTypes.default.string,
  noMb: _propTypes.default.bool,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var _default = TextField;
exports.default = _default;